var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.isLoading === false
        ? [
            _c(
              "ButtonWithCheckMark",
              {
                attrs: {
                  active: _vm.item.isActive,
                  title: _vm.item.text || _vm.item.preferredLabel,
                  isOneLine: _vm.item.description ? false : true,
                },
                on: {
                  emitClick: function ($event) {
                    return _vm.clickedItem()
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _vm.item.description
                      ? _c(
                          "ReadMore",
                          {
                            staticClass: "mt-2",
                            attrs: { content: _vm.item.description },
                          },
                          [
                            _vm.alternativeLabels.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "mt-2" },
                                  [
                                    _c("span", { staticClass: "mr-2" }, [
                                      _vm._v(_vm._s(_vm.t.general_Also_Called)),
                                    ]),
                                    _vm._l(
                                      _vm.alternativeLabels,
                                      function (label, lidx) {
                                        return _c(
                                          "b-badge",
                                          {
                                            key: lidx,
                                            staticClass:
                                              "my-1 rounded p-1 mr-2 text-left white-space-normal",
                                            attrs: {
                                              variant: "outline-secondary",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.trimLabel(label)))]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]
        : [
            _c("b-skeleton", {
              attrs: {
                height: _vm.item.description ? "82px" : "52px",
                width: "100%",
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }